import React, {Component} from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';

import './SvgIcon.less';

const SvgIcon = ({namespace, icon, className, ...props}) => {
    return (
        <svg className={classnames(className, `SvgIcon--${icon}`, 'SvgIcon')} {...props}>
            <use xlinkHref={`#${namespace}--${icon}`} />
        </svg>
    );
};

SvgIcon.defaultProps = {
    namespace: 'front'
};

SvgIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    namespace: PropTypes.string
};

export default SvgIcon;



// WEBPACK FOOTER //
// ./assets/app/common/components/SvgIcon/SvgIcon.jsx